import constants from './constants';
import control from './controls/control';

const { common } = constants;

const getExtension = () => ({
  slug: common.SLUG,
  title: 'Link Extension',
  description: 'Extension for editing links',
  settings: {
    querySelector: "ws-text a, ws-button a, [type='gdpr-consent'] a",
  },
  ui: {
    control: [control],
  },
});

export default getExtension;
